import { Icon, Shadow, Text } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Box, Button, HStack, Spacer, VStack } from 'native-base';
import React from 'react';

import { ItemResponsiveProps } from '.';

export const MobileItem: React.FC<ItemResponsiveProps> = ({
  asset,
  descriptionType,
  description,
  requestedDate,
  settlementDate,
  formattedValue,
  quantity,
  valueIsPositive,
  statusIcon,
  statusDescription,
  cancelButtonIsDisabled,
  productType,
  handleCancelMovement,
}) => {
  const isTreasury = productType === 'Treasury';

  return (
    <Shadow borderRadius={BoxBorder.heavy} p="inline.xxxs" level={3} my="stack.nano">
      <VStack space="inline.xxxs" borderRadius={BoxBorder.heavy}>
        <HStack alignItems="center" justifyContent="space-between">
          <Text variant="semibold" color="neutral.black" fontSize="xs">
            {descriptionType}
          </Text>
          <Text color="neutral.black" fontSize="xs">
            {description}
          </Text>
        </HStack>
        <Box h={0.5} bg="neutral.lightest" />
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.dark" fontSize="md">
            Data de solicitação
          </Text>
          <Text color="neutral.dark" fontSize="md">
            {requestedDate}
          </Text>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.dark" fontSize="md">
            Data de liquidação
          </Text>
          <Text color="neutral.dark" fontSize="md">
            {settlementDate}
          </Text>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.dark" fontSize="md">
            Valor
          </Text>
          {isTreasury ? (
            <VStack space="stack.quarck">
              <Text fontSize="xs" color="neutral.black" variant="bold">
                {formattedValue}
              </Text>
              <Text fontSize="xs" color="neutral.black">
                Quantidade {quantity}
              </Text>
            </VStack>
          ) : (
            <Text
              color={valueIsPositive ? 'feedback.success.default' : 'feedback.error.default'}
              fontSize="md">
              {formattedValue}
            </Text>
          )}
        </HStack>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.dark" fontSize="md">
            Ativo
          </Text>
          <Text color="neutral.dark" fontSize="md">
            {asset}
          </Text>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.dark" fontSize="md">
            Status
          </Text>
          <HStack alignItems="center" space="stack.quarck">
            {statusIcon}
            <Text fontSize="xs" color="neutral.black">
              {statusDescription}
            </Text>
          </HStack>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Spacer />
          <Button
            variant="textLink"
            isDisabled={cancelButtonIsDisabled}
            _disabled={{
              _text: {
                color: 'neutral.light',
              },
            }}
            onPress={handleCancelMovement}
            _text={{ color: 'feedback.error.default' }}
            endIcon={
              <Icon
                testID="cancel-button-icon"
                name={'Trash'}
                size="xxs"
                color={cancelButtonIsDisabled ? 'neutral.light' : 'feedback.error.default'}
              />
            }>
            Cancelar
          </Button>
        </HStack>
      </VStack>
    </Shadow>
  );
};
